/*
  _constants.js

  This file holds all constant variables to be used throughout javascripts

  To create new constant variable/variables, declare const variable/array 
  and export it/them.

  For convention, please only use uppercase for variable name.
*/

// breakpoints are in px
const BREAKPOINTS = {
  DESKTOP: 1024,
  TABLET: 768,
};

const VIEWMODE = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
};

const Util = {
  getUrlParam(name, url) {
    let tempURL = url;
    if (!url) tempURL = window.location.href;
    // eslint-disable-next-line
    const tempName = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${tempName}(=([^&#]*)|&|#|$)`, 'i');
    const results = regex.exec(tempURL);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },
  validateGuid(input) {
    const pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return pattern.test(input);
  },
};

const ANIMATION_DURATION = 150; // animation duration is ms (0.15s)


const REBATE_FORM_PDF_FILENAMES = {
  CRM_ADD_REBATE: 'CRM-Add-a-Rebate',
  CRM_CHANGE_REBATE_APPLICANT: 'CRM-Change-Rebate-Applicant',
  MEMBER_PORTAL_ADD_REBATE: 'MemberPortal-Add-a-Rebate',
  CRM_CHANGE_COVER_ADD_REBATE: 'CRM-Change-Product-Add-a-Rebate',
  MEMBER_PORTAL_CHANGE_PRODUCT_ADD_REBATE: 'MemberPortal-Change-Product-Add-a-Rebate',
  GAQ_JOL_REBATE: 'CRM-Join-online-Add-a-Rebate',
};

export { ANIMATION_DURATION, BREAKPOINTS, Util, VIEWMODE, REBATE_FORM_PDF_FILENAMES };
